import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { faqs } from "../data/landing";
export function FaqSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="bg-paper" data-id="element-69" data-mp="1bmllx5jgptjf">
      <div className="mx-auto max-w-3xl px-5 py-16 md:py-24" data-id="element-70" data-mp="1gj3n5vfl39r0">
        <h2 className="text-center font-display text-3xl font-semibold text-ink md:text-4xl" data-id="element-71" data-mp="1glgev0b58yh9">
          Questions fréquentes
        </h2>

        <ul className="mt-10 divide-y divide-ink/15 border-y border-ink/15" data-id="element-72" data-mp="28b1c93uec6xl">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          const panelId = `faq-panel-${i}`;
          return <li key={faq.q} data-id="element-73" data-mp="1zh6ggmf5zsum" data-mpi={i}>
                <h3 data-id="element-74" data-mp="1zgd67bgzyl7q">
                  <button type="button" aria-expanded={isOpen} aria-controls={panelId} onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center justify-between gap-4 py-5 text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-terracotta" data-id="element-75" data-mp="2n8bx33sxip5z">
                    <span className="font-display text-lg font-semibold leading-snug text-ink" data-id="element-76" data-mp="1ektv34k9qsxr">
                      {faq.q}
                    </span>
                    <PlusIcon className={`h-5 w-5 shrink-0 text-terracotta transition-transform duration-200 ease-out ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" data-id="element-77" data-mp="19stwbffxq62r" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-78" data-mp="1xioaq1fwk2p4">
                  {isOpen && <motion.div id={panelId} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: "auto",
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-79" data-mp="1skmtlm21edga">
                      <p className="pb-6 pr-8 leading-relaxed text-ink-soft" data-id="element-80" data-mp="237ehbym4lseu">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}